export default __webpack_public_path__ + "static/media/maduro-3Closed.d04df1e6.jpg";